"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var themes_1 = require("../../themes");
exports.default = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        title: function (props) { return ({
            color: props.titleColor === 'black' ? theme.palette.text.primary : theme.palette.primary.main,
            textTransform: props.uppercase ? 'uppercase' : 'capitalize',
            marginBottom: 0,
        }); },
        card: function (props) { return (__assign(__assign({ marginBottom: theme.spacing(1), padding: theme.spacing(2), borderRadius: 20, borderColor: props.borderColor }, (props.smallerCard ? { paddingBottom: 0 } : { paddingBottom: theme.spacing(2) })), { paddingBottom: !props.paddingB ? '16px' : "".concat(props.paddingB, "px") })); },
        content: {
            padding: 0,
            '&.MuiCardContent-root:last-child': {
                paddingBottom: 0,
            },
        },
        icon: {
            color: themes_1.materialColors.blue[100],
        },
    });
});
